import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "antd";
import Component from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
const Navigation = () => {
  const dispatch = useDispatch();
  const { SelectBox, Radio } = Component;

  return (
    <>
      <Row justify={"center"}>
        <Col sm={20} className="text-center">
          <div className="text-center mt-5">
            <h2 style={{ color: "#5A7890", marginBottom: "3rem" }}>
              Navigation Page
            </h2>
          </div>
          <Link target="_blank" to="/maintenance" style={{ margin:"10px"}}>
              <Button style={{ backgroundColor: "#5A7890", color:"#fff"}}>Maintenance Request</Button>
            </Link>
          <Link target="_blank" to="/tenant" style={{ margin:"10px"}}>
              <Button style={{ backgroundColor: "#5A7890", color:"#fff"}}>Tenant Registrtion</Button>
            </Link>
          <Link target="_blank" to="/additional" style={{ margin:"10px"}}>
              <Button style={{ backgroundColor: "#5A7890", color:"#fff"}}>Add Additional Fee</Button>
            </Link>
          <Link target="_blank" to="/disclaimer" style={{ margin:"10px"}}>
              <Button style={{ backgroundColor: "#5A7890", color:"#fff"}}>Add Disclaimer</Button>
            </Link>
        </Col>
      </Row>
    </>
  );
};
export default Navigation;
